/*
 * XYNE Redesign — Recently viewed products
 *
 * Two responsibilities:
 *   1. Capture the current product on PDP visits → localStorage
 *   2. Render the saved list in any [data-rd-recently] section on the page
 *
 * Storage shape: localStorage key 'rd_recently_viewed_v1' = array of
 *   { handle, title, image, price, url, captured_at }
 *
 * Capped at 12 entries; FIFO eviction. Excludes the current PDP from the
 * rendered list so customers don't see "you just viewed this".
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'rd_recently_viewed_v1';
  var MAX_ENTRIES = 12;

  function readStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeStorage(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ENTRIES)));
    } catch (e) {
      // localStorage may be disabled (private browsing) — silently no-op
    }
  }

  function capture() {
    // Only capture when we're on a PDP — detected by presence of a product
    // schema or template body class. We use the section's data attribute
    // which is set when rendering on a product template.
    var section = document.querySelector('[data-rd-recently]');
    var currentHandle = section ? section.dataset.rdCurrentHandle : '';
    if (!currentHandle) return;

    // Build a snapshot from the current PDP. We try the redesigned PDP hero
    // selectors first; fall back to schema metadata if available.
    var titleEl = document.querySelector('.rd-pdp__title');
    var priceEl = document.querySelector('.rd-pdp__price');
    var mainImg = document.getElementById('rd-pdp-main-img');

    var snapshot = {
      handle: currentHandle,
      title: titleEl ? titleEl.textContent.trim() : currentHandle.replace(/-/g, ' '),
      image: mainImg ? mainImg.src : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      url: '/products/' + currentHandle,
      captured_at: Date.now()
    };

    var list = readStorage();
    // Remove any existing entry with the same handle (move to front)
    list = list.filter(function (item) { return item.handle !== currentHandle; });
    // Prepend current
    list.unshift(snapshot);
    writeStorage(list);
  }

  function render() {
    var sections = document.querySelectorAll('[data-rd-recently]');
    if (!sections.length) return;

    var list = readStorage();
    sections.forEach(function (section) {
      var rail = section.querySelector('[data-rd-recently-rail]');
      if (!rail) return;
      var currentHandle = section.dataset.rdCurrentHandle;
      var minItems = parseInt(section.dataset.rdMinItems, 10) || 2;

      // Filter out the current product (so PDPs don't show "you just viewed this")
      var items = list.filter(function (it) { return it.handle && it.handle !== currentHandle; });

      if (items.length < minItems) {
        section.hidden = true;
        return;
      }

      // Cap visible items at 8 for layout sanity
      items = items.slice(0, 8);

      rail.innerHTML = items.map(cardHtml).join('');
      section.hidden = false;
    });
  }

  function cardHtml(item) {
    return '<a class="rd-recently__card" role="listitem" href="' + escapeAttr(item.url) + '" data-rd-recently-handle="' + escapeAttr(item.handle) + '">' +
        '<div class="rd-recently__media">' +
          (item.image ? '<img src="' + escapeAttr(item.image) + '" alt="" loading="lazy" width="220" height="220">' : '') +
        '</div>' +
        '<div class="rd-recently__body">' +
          '<h3 class="rd-recently__name">' + escapeHtml(item.title) + '</h3>' +
          (item.price ? '<span class="rd-recently__price">' + escapeHtml(item.price) + '</span>' : '') +
        '</div>' +
      '</a>';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function init() {
    capture();   // PDP capture (no-op on non-PDP pages)
    render();    // render the rail wherever the section is mounted
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
